






























  import { DialogueErreur } from '@/commun/components/dialogue-erreur';
  import { BanniereUlaval } from '@/components/cadre/banniere-ulaval/';
  import { FooterGof } from '@/components/cadre/footer/';
  import Vue from 'vue';
  import SnackbarNotificationGlobale from './commun/components/snackbars/snackbar-notification-globale.vue';
  export default Vue.extend({
    name: 'App',
    components: {
      FooterGof,
      BanniereUlaval,
      DialogueErreur,
      SnackbarNotificationGlobale,
    },
    data: () => ({
      dialogueErreurOuvert: false,
    }),
    computed: {
      erreur(): Error | undefined {
        return this.$store.getters.erreur;
      },
    },
    watch: {
      erreur(erreur: Error) {
        if (erreur) {
          this.dialogueErreurOuvert = true;
          return;
        }
        this.dialogueErreurOuvert = false;
      },
      dialogueErreurOuvert(valeur: boolean) {
        if (!valeur) {
          this.retirerErreur();
        }
      },
    },
    methods: {
      retirerErreur(): void {
        this.$store.dispatch('retirerErreur');
      },
    },
  });
